import { Box, Center, CircularProgress, useColorModeValue } from '@chakra-ui/react';
import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from '../../components/navbar/NavbarAdmin';
import Sidebar from '../../components/sidebar/Sidebar';
import Footer from '../../components/footer/FooterAdmin';
import routes, { AppRoute, filterRoutesByRole } from '../../routes';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { RootState } from '../../store/store';
import { verifyAuth } from '../../store/features/auth/auth.slice';

export default function AdminLayout(props: { [x: string]: any }) {
	const dispatch = useAppDispatch();
	const location = useLocation();
	const { authenticated, waitingAuth, role, leilaoEnabled, liveLeadEnabled } = useAppSelector(
		(state: RootState) => state.auth
	);
	const bg = useColorModeValue('secondaryGray.300', 'navy.900');

	const allowedRoutes = filterRoutesByRole(routes, { role, leilaoEnabled, liveLeadEnabled });

	useEffect(() => {
		dispatch(verifyAuth());
	}, [dispatch]);

	const getActiveRoute = (list: AppRoute[]): string => {
		for (const r of list) {
			if (location.pathname.includes(r.layout + r.path)) {
				return r.name;
			}
		}
		return 'Datric';
	};

	if (waitingAuth || authenticated === undefined) {
		return (
			<Center h='100vh' bg={bg}>
				<CircularProgress isIndeterminate color='brand.500' />
			</Center>
		);
	}

	if (!authenticated) {
		return <Navigate to='/auth' replace />;
	}

	document.documentElement.dir = 'ltr';

	return (
		<Box bg={bg} minH='100vh'>
			<Sidebar routes={allowedRoutes} />
			<Box
				float='right'
				minHeight='100vh'
				height='100%'
				overflow='auto'
				position='relative'
				maxHeight='100%'
				w={{ base: '100%', xl: 'calc( 100% - 260px )' }}
				maxWidth={{ base: '100%', xl: 'calc( 100% - 260px )' }}
				transition='all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)'>
				<Navbar brandText={getActiveRoute(allowedRoutes)} routes={allowedRoutes} />
				<Box mx='auto' p={{ base: '20px', md: '30px' }} pe='20px' minH='90vh' pt='20px'>
					<Routes>
						{allowedRoutes.map((route, key) => (
							<Route path={route.path} element={<route.component />} key={key} />
						))}
						<Route path='*' element={<Navigate to={allowedRoutes[0]?.path || '/consulta'} replace />} />
					</Routes>
				</Box>
				<Footer />
			</Box>
		</Box>
	);
}
